export default __webpack_public_path__ + "static/media/phone_black.8c74373d.svg";